<template>
  <div>
    <loading v-if="!alreadyLoaded" full-screen="false" size="small" />

    <div v-else class="panel-body">
      <div class="duplicated-reenrollments" v-if="duplicatedReenrollments">
        <hr>
        <div class="alert alert-danger">
          <strong>Erro na importação: </strong>
          Alguns alunos da tabela importada já possuem uma rematrícula em andamento.
          Remova esses alunos da tabela para prosseguir com a importação.
        </div>

        <div>CPF's dos alunos que já estão em processo de rematrícula:</div>
        <br>
        <ul>
          <li v-for="(cpf, index) in duplicatedReenrollments" :key="index">
            {{ cpf }}
          </li>
        </ul>

        Para alterar uma rematrícula existente, abra uma task para o time de OPS.
        <hr>
      </div>

      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="table-centralized">
              ID
            </th>
            <th class="table-centralized">
              Período
            </th>
            <th class="table-centralized">
              Status
            </th>
            <th class="table-centralized">
              Iniciado em
            </th>
            <th class="table-centralized">
              Finalizado em
            </th>
            <th class="table-centralized">
              <dropdown-filter-list
                text-displayed="Filtro de status da rematrícula"
                :reference-id="`reenrollment-contracts-${this.institution.id}`"
                :items-filter="reenrollmentContractsFilter"
                :pre-selected-items="reenrollmentContractEnabledFilter"
                @items-changed="reenrollmentContractsFilterChanged"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="this.reenrollmentContracts.length === 0">
            <td colspan="9" class="table-centralized">
              Não existe período de rematrícula para está instituição.
            </td>
          </tr>
          <tr v-else-if="this.filteredReenrollmentContracts.length === 0">
            <td colspan="9" class="table-centralized">
              Nada a exibir considerando o filtro atual.
            </td>
          </tr>
          <reenrollment-contract-item
            v-for="reenrollmentContract in this.filteredReenrollmentContracts"
            :reenrollment-contract="reenrollmentContract"
            :key="reenrollmentContract.id"
            @import="openFileModal"
            @disable="openConfirmModal"
            v-else
          />
        </tbody>
      </table>
      <input
        ref="fileInput"
        type="file"
        class="form-control"
        style="display:none"
        @change="importStudentsReenrollment"
      >
      <confirm-modal
        v-if="showConfirmModal"
        title="Finalizar período de rematrícula"
        message="Você tem certeza que deseja finalizar este período de rematrícula? Isso irá interromper todas as
        rematrículas não finalizadas deste período."
        @close="closeConfirmModal"
        @confirm="disableReenrollmentContract"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Loading from 'components/Loading';
import ConfirmModal from 'components/ConfirmModal';
import DropdownFilterList from 'components/DropdownFilterList';
import ReenrollmentContractsService from 'services/ReenrollmentContractsService';
import ReenrollmentContractItem from './ReenrollmentContractItem';

export default {
  data() {
    return {
      reenrollmentContractsFilter: [
        { value: true, text: 'Em andamento' },
        { value: false, text: 'Finalizado' },
      ],
      reenrollmentContractEnabledFilter: [true],
      showConfirmModal: false,
      currentReenrollmentContractId: null,
      duplicatedReenrollments: null,
    };
  },
  components: {
    ConfirmModal,
    DropdownFilterList,
    Loading,
    ReenrollmentContractItem,
  },
  computed: {
    ...mapState([
      'institution',
      'reenrollmentContracts',
    ]),
    alreadyLoaded() {
      return !!this.reenrollmentContracts;
    },
    filteredReenrollmentContracts() {
      return this.reenrollmentContracts
        .filter(({ enabled }) => this.reenrollmentContractEnabledFilter.includes(enabled));
    },
  },
  methods: {
    ...mapActions([
      'loadReenrollmentContracts',
    ]),
    closeConfirmModal() {
      this.showConfirmModal = false;
    },
    disableReenrollmentContract() {
      this.$loader.show();
      this.disableReenrollmentContractService();
    },
    disableReenrollmentContractService() {
      ReenrollmentContractsService
        .disableReenrollmentContract(this.currentReenrollmentContractId, this.institution.id)
        .then(() => {
          this.reloadReenrollmentContracts();
          this.$alert.notifySuccess('Período de rematrícula encerrado com sucesso!');
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao encerrar período de rematrícula.');
        })
        .finally(() => {
          this.currentReenrollmentContractId = null;
          this.closeConfirmModal();
          this.$loader.hide();
        });
    },
    importStudentsReenrollment(event) {
      const file = event.target.files[0];

      if (this.isInvalidFormatFile(file)) {
        this.$alert.notifyAlert('Arquivo com formato inválido!');
        return;
      }

      this.$loader.show();
      this.importStudentsReenrollmentService(file);
    },
    importStudentsReenrollmentService(file) {
      ReenrollmentContractsService
        .importStudentsReenrollmentCsv(this.currentReenrollmentContractId, this.institution.id, file)
        .then((response) => {
          if (response.data.duplicated_reenrollments) {
            this.duplicatedReenrollments = response.data.duplicated_reenrollments;
          } else {
            this.$alert.notifySuccess('Alunos importados com sucesso!');
          }
        })
        .catch(() => {
          this.$alert.notifyAlert('Erro ao importar alunos.');
        })
        .finally(() => {
          this.currentReenrollmentContractId = null;
          this.clearFileInput();
          this.$loader.hide();
        });
    },
    isInvalidFormatFile(file) {
      if (!!file && RegExp('.*\\.xlsx$', 'g').test(file.name)) return false;
      return true;
    },
    openFileModal(reenrollmentContractId) {
      this.currentReenrollmentContractId = reenrollmentContractId;
      this.$refs.fileInput.click();
    },
    openConfirmModal(reenrollmentContractId) {
      this.currentReenrollmentContractId = reenrollmentContractId;
      this.showConfirmModal = true;
    },
    clearFileInput() {
      this.$refs.fileInput.value = '';
    },
    reenrollmentContractsFilterChanged(items) {
      this.reenrollmentContractEnabledFilter = items;
    },
    reloadReenrollmentContracts() {
      this.loadReenrollmentContracts(this.institution.id);
    },
  },
};
</script>

<style lang="scss">
.duplicated-reenrollments {
  margin-bottom: 40px;
}
</style>
